import * as React from 'react';
import * as lodash from 'lodash';
import * as style from './style.sass';

interface Properties {
  onChange: (indices: number[]) => any;
  disabledIndices: number[];
  startIndex: number;
  preview: string | Blob | null;
  width: number;
  height: number;
}

export class Indices extends React.Component<Properties> {
  onSwitchIndex = (index: number) => {
    const { startIndex, disabledIndices, onChange, width, height } = this.props;

    if (index === startIndex) {
      return;
    }

    const existingIndex = disabledIndices.indexOf(index);

    if (existingIndex !== -1) {
      const copy = [...this.props.disabledIndices];
      copy.splice(existingIndex, 1);
      onChange(copy);
    } else {
      if (width * height - disabledIndices.length <= 4) {
        return;
      }

      onChange(disabledIndices.concat(index));
    }
  }

  render() {
    const { disabledIndices, startIndex, preview, width, height } = this.props;
    const stepWidth = 100 / width;
    const stepHeight = 100 / height;

    if (!preview) {
      return null;
    }

    const url = typeof preview === 'string' ? preview : window.URL.createObjectURL(preview);

    return (<>
      <div className={style.indices}>
        <img src={url}/>
        {lodash.range(0, height).map((row: number) => {
          return lodash.range(0, width).map((column: number) => {
            const index = row * width + column;
            return (<div
              key={index}
              onClick={this.onSwitchIndex.bind(this, index)}
              className={
                `${disabledIndices.indexOf(index) !== -1 ? style.disabled : ''} ` +
                `${index === startIndex ? style.start : ''}`}
              style={{
                top: `${row * stepHeight}%`,
                bottom: `${100 - (row * stepHeight + stepHeight)}%`,
                left: `${column * stepWidth}%`,
                right: `${100 - (column * stepWidth + stepWidth)}%`,
              }}
            >
              {index}
            </div>);
          });
        })}
      </div>
      {(width * height - disabledIndices.length <= 4) && <div className={style.error}>
        You cannot add more disabled indices.
      </div>}
    </>);
  }
}
